import {PanelBase} from "./panelBase";
import {Integrations} from "../integrations";
import {BmdConfigDialog} from "./bmdConfigDialog";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {IntegrationType} from "@/shared/timrTypes";

export interface BmdAbsenceTypeConfig {
	[workingTimeTypeId: string]: string;
}

export interface BmdDivNlzIdConfig {
	[workingTimeTypeId: string]: number;
}

export interface BmdConfig {
	companyId: string;
	absenceTypes: BmdAbsenceTypeConfig;
	divNlzIds?: BmdDivNlzIdConfig;
	homeOfficeAllowanceWageType?: string | null;
	timeAccountAbsenceExportEnabled: boolean;
	timeAccountBalanceExportEnabled: boolean;
	timeAccountPayrollExportEnabled: boolean;
}

export class BMD extends PanelBase {

	constructor() {
		super();
	}

	private connectedCallback() {
		this.innerHTML = this.renderPanel({
			logoHtml: `<img src="/timr/images/integrations/bmd.svg" alt="BMD Integration" height="36px">`,
			topActionsHtml: this.renderEditActionButton()
		});
		this.initListeners();
	}

	private initListeners() {
		$(this).find("#edit").on("click", () => {
			BmdConfigDialog.edit(this._integration, (this._integration.configuration as BmdConfig));
		});
		this.querySelector("[data-delete-integration]").addEventListener("click", () => {
			BootstrapModal.confirm({
				title: messages["dialog.delete.confirm"],
				message: messages["integrations.bmd.delete.message"],
				yesAction: (confirmModal) => {
					confirmModal.close();
					Integrations.triggerDeletedIntegrationEvent(IntegrationType.BMD, this.integration.id);
				}
			});
		});
	}

	protected updateBanner(): void {
		// Nothing to do here
	}

	public onIntegrationAdded() {
		// Nothing to do here
	}
}
